import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListCiiuActivities } from "../../../components/Admin/CiiuActivities";
import { useLanguage } from "../../../contexts";
import "./CiiuActivities.scss";

export function CiiuActivities() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    { menuItem: t("actives"),   render: () => <Tab.Pane attached={false}><ListCiiuActivities active={true}  reload={reload} onReload={onReload} /></Tab.Pane> },
    { menuItem: t("inactives"), render: () => <Tab.Pane attached={false}><ListCiiuActivities active={false} reload={reload} onReload={onReload} /></Tab.Pane> },
  ];

  return (
    <div className="ciiu-activities-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="ciiu-activities-page-header-wrapper">
        <div className="ciiu-activities-page-header">
          <span className="ciiu-activities-page-title">{t("ciiu_activities")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
